import iconDoc1 from './images/medical-ins-card.svg';
import iconDoc2 from './images/social-ins.svg';
import iconDoc3 from './images/bank-statement-3.svg';
import iconDoc4 from './images/lab-contract.svg';
import iconDoc5 from './images/payslip-any.svg';
import iconDoc6 from './images/bill-any.svg';

// Document Name must be base on Docs Type of Customer-bod-service
export const BANK_STATMENT_3 = 'BANK_STATMENT_3';
export const LAB_CONTRACT = 'LAB_CONTRACT';
export const PAY_SLIP_ANY = 'PAY_SLIP_ANY';
export const BILL_ANY = 'BILL_ANY';
export const MEDICAL_INS_CARD = 'MEDICAL_INS_CARD';
export const SOCIAL_INSURANCE = 'SOCIAL_INSURANCE';
export const NEW_CUSTOMER_CREATED = 'CREATED';

export const LIMIT_DOCUMENTS = 2;

export const DOCS_LABEL = {
  BANK_STATMENT_3: 'Sao kê lương',
  LAB_CONTRACT: 'Hợp đồng lao động',
  PAY_SLIP_ANY: 'Bảng lương',
  BILL_ANY: 'Hóa đơn điện hoặc nước',
  MEDICAL_INS_CARD: 'Thẻ bảo hiểm y tế​',
  SOCIAL_INSURANCE: 'Bảo hiểm xã hội​',
};

export const configs = [
  {
    id: MEDICAL_INS_CARD,
    label: DOCS_LABEL.MEDICAL_INS_CARD,
    point: 20,
    note: 'Thẻ còn thời hạn',
    icon: iconDoc1,
  },
  {
    id: SOCIAL_INSURANCE,
    label: DOCS_LABEL.SOCIAL_INSURANCE,
    point: 20,
    note: 'Bảo hiểm xã hội trên ứng dụng VSSID',
    icon: iconDoc2,
  },
  {
    id: BANK_STATMENT_3,
    label: DOCS_LABEL.BANK_STATMENT_3,
    point: 50,
    note: 'Từ ngân hàng hoặc web, ứng dụng của ngân hàng',
    icon: iconDoc3,
  },
  {
    id: LAB_CONTRACT,
    label: DOCS_LABEL.LAB_CONTRACT,
    point: 40,
    note: 'Hợp đồng yêu cầu còn hiệu lực',
    icon: iconDoc4,
  },
  {
    id: PAY_SLIP_ANY,
    label: DOCS_LABEL.PAY_SLIP_ANY,
    point: 30,
    note: 'Từ nhân sự hoặc web công ty',
    icon: iconDoc5,
  },
  {
    id: BILL_ANY,
    label: DOCS_LABEL.BILL_ANY,
    point: 20,
    note: '3 tháng gần nhất',
    icon: iconDoc6,
  },
];
